import { createContext, useContext } from 'react'

interface MessagesUnreadContextValue {
  totalUnread: number
  refresh: () => Promise<void>
}

const MessagesUnreadContext = createContext<MessagesUnreadContextValue | null>(
  null,
)

/**
 * Reads the unread-message count + refresh. Throws outside the provider.
 *
 * @returns {MessagesUnreadContextValue}
 */
const useMessagesUnread = (): MessagesUnreadContextValue => {
  const context = useContext(MessagesUnreadContext)
  if (context === null) {
    throw new Error(
      'useMessagesUnread must be used within a MessagesUnreadProvider',
    )
  }
  return context
}

export {
  MessagesUnreadContext,
  type MessagesUnreadContextValue,
  useMessagesUnread,
}
